import { render, staticRenderFns } from "./BtnsActionReport.vue?vue&type=template&id=668d7238&scoped=true&"
import script from "./BtnsActionReport.vue?vue&type=script&lang=js&"
export * from "./BtnsActionReport.vue?vue&type=script&lang=js&"
import style0 from "./BtnsActionReport.vue?vue&type=style&index=0&id=668d7238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d7238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
